import React from 'react';
import DfbImage from '../ui-kit/dfb_image';
import { Transformation } from "cloudinary-react";

const CCardAuthor = (props) => {
  return(
    <div className="dfb-Card-author">
      <div className="dfb-Card-authorImageContainer">
        { props.author.authorPhoto && props.author.authorPhoto.src &&
          <DfbImage
            add_class="dfb-Card-authorImage"
            image={{
              src: props.author.authorPhoto.src,
              alternative: `${props.author.firstname} ${props.author.lastname}`
            }}
            lazyload={(props.force_image_loading ? false : true)}
            aspect_ratio="1:1"
          >
            <Transformation
              crop="fill"
              gravity="faces:center"
              width="192"
              height="192"
              quality="auto"
              fetchFormat="auto"
            />
          </DfbImage>
          }
      </div>
      <p className="dfb-Paragraph dfb-Paragraph--small dfb-Card-authorName">
        { props.author.firstname } { props.author.lastname }
      </p>
    </div>
  )
}

export default CCardAuthor;